<template>
  <a-modal
    :maskClosable="false"
    :cancelText="'取消'"
    :okText="'确定'"
    :width="1200"
    :title="isAdd ? '创建放假计划' : '修改放假计划'"
    v-model="visible"
    :footer="null"
    @cancel="clickcancel"
  >
    <a-form :form="form" v-show="step === 1">
      <!-- 放假计划名称 -->
      <a-form-item
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        label="放假计划名称："
      >
        <a-input
          v-decorator="[
            'planName',
            {
              rules: [
                {
                  required: true,
                  pattern: /^.{2,45}$/,
                  message: '请输入长度为2~45位的放假计划名称',
                },
              ],

              validateTrigger: 'change',
            },
          ]"
          placeholder="请输入"
        >
        </a-input>
      </a-form-item>
      <!-- 放假计划开始日期 -->
      <a-form-item
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        label="放假计划开始日期："
      >
        <a-date-picker
          v-model="startDate"
          format="YYYY-MM-DD"
          placeholder="开始时间"
          :disabledDate="disabledStartDate"
          :showTime="false"
          :showToday="false"
          v-decorator="[
            'startDate',
            {
              rules: [
                {
                  required: true,
                  message: '请选择开始时间',
                },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>
      <a-form-item
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        label="放假计划结束日期："
      >
        <a-date-picker
          :showToday="false"
          v-model="endDate"
          format="YYYY-MM-DD"
          placeholder="结束时间"
          :showTime="false"
          :disabledDate="disabledEndDate"
          v-decorator="[
            'endDate',
            {
              rules: [
                {
                  required: true,
                  message: '请选择结束时间',
                },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>
      <a-form-item
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        label="放假天数："
      >
        {{ this.startDate && this.endDate ? this.differenceTime : 0 }}天
      </a-form-item>
      <a-form-item class="tip">
        <p>⚠️注意:</p>
        <p>1、放假计划指开始到结束日期范围内不安排课节</p>
        <p>2、设置成功后，所有已安排课节也会延后到放假范围外</p>
        <p>3、放假计划日期范围内不可人工插入课节</p>
      </a-form-item>
    </a-form>

    <div class="step-two" v-show="step === 2">
      <div class="influence">受此放假计划影响班级：{{ this.total }}个</div>
      <a-table
        :loading="loading"
        bordered
        :columns="columns"
        :dataSource="affectedClassList"
        style="margin-bottom: 15px"
        :pagination="false"
      >
        <span slot="teachingPlan" slot-scope="text, record">
          <template>
            <div
              v-for="(item, index) in JSON.parse(record.teachingPlan) || []"
              :key="index"
            >
              <span>{{ item.classWeeks | weekName }}&nbsp;&nbsp;</span>
              <span>{{ item.classTime }}</span>
            </div>
          </template>
        </span>
      </a-table>
    </div>

    <div class="step-three" v-show="step === 3">
      <a-form>
        <a-form-item
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          label="放假计划名称："
          >{{ this.planName }}</a-form-item
        >
        <a-form-item
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          label="放假计划开始日期："
          >{{ this.showStartDate }}</a-form-item
        >
        <a-form-item
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          label="放假计划结束日期："
          >{{ this.showEndDate }}</a-form-item
        >
        <a-form-item
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          label="放假天数："
          >{{ this.differenceTime }}天</a-form-item
        >
        <a-form-item
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          label="受此放假计划影响班级："
          >{{ this.total }}个</a-form-item
        >
        <div class="msg">
          请再次确认以上放假计划信息和影响班级数，若是灵活排课的课节和放假计划冲突将被删除。一旦确认则立即生效，后续不支持修改或复原，且可能会有课节超过学期设置、老师时段冲突、教室冲突等，请谨慎操作！
        </div>
      </a-form>
    </div>

    <div class="steps-oper">
      <a-button
        v-show="step === 2 || step === 3"
        class="prev"
        type="Default  "
        @click="minusStep"
      >
        上一步
      </a-button>
      <a-button
        v-show="step === 1 || step === 2"
        class="prev"
        type="primary"
        @click="addStep"
        :loading="addStepLoading"
      >
        下一步
      </a-button>
      <a-button
        :loading="submitLoading"
        v-show="step === 3"
        class="prev"
        type="primary"
        @click="submit"
      >
        完成
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
import education from '../../api/education'
import Vue from 'vue'
const columns = [
  {
    title: '班级名称',
    dataIndex: 'className',
    width: 150,
  },
  {
    title: '老师',
    dataIndex: 'teacherName',
    width: 100,
  },
  {
    title: '教室名称',
    dataIndex: 'placeName',
    width: 100,
  },
  {
    title: '适用年级',
    dataIndex: 'gradeScope',
    width: 200,
  },
  {
    title: '上课计划',
    dataIndex: 'teachingPlan',
    scopedSlots: { customRender: 'teachingPlan' },
    width: 150,
  },
  {
    title: '班级状态',
    dataIndex: 'statusText',
    width: 70,
  },
  {
    title: '备注',
    dataIndex: 'tipMessage',
  },
]
export default {
  data() {
    return {
      moment,
      form: this.$form.createForm(this),
      visible: false,
      startDate: null,
      endDate: null,
      showStartDate: null,
      showEndDate: null,
      step: 1,
      schoolId: Vue.ls.get('schoolId'),
      isAdd: true,
      loading: false,
      affectedClassList: [],
      columns,
      total: 0,
      planName: '',
      currentPage: {}, // 分页
      differenceTime: '',
      id: '',
      addStepLoading: false,
      submitLoading: false,
    }
  },
  watch: {
    startDate() {
      this.differenceTime = this.endDate.diff(this.startDate, 'days') + 1
    },
    endDate() {
      this.differenceTime = this.endDate.diff(this.startDate, 'days') + 1
    },
  },
  props: ['currentPageParent'],
  methods: {
    // 初始化
    init(type, params) {
      this.visible = true
    },
    //下一步
    addStep() {
      if (this.step === 1) {
        this.form.validateFields((err, values) => {
          if (!err) {
            if (moment(values.endDate) < moment(values.startDate)) {
              this.$message.error('结束日期不得小于开始日期')
              return
            }
            this.showStartDate = moment(this.startDate).format('YYYY-MM-DD')
            this.showEndDate = moment(this.endDate).format('YYYY-MM-DD')
            this.planName = values.planName
            const data = {
              schoolId: this.schoolId,
              startDate: moment(this.startDate).format('YYYY-MM-DD'),
              endDate: moment(this.endDate).format('YYYY-MM-DD'),
              planName: this.planName,
              days: Math.ceil((this.endDate - this.startDate) / 86400000),
            }

            this.loading = true
            this.addStepLoading = true
            // console.log('affectedClassdata', data)
            education
              .affectedClass(data)
              .then((res) => {
                // console.log('affectedClassres', res)
                this.total = res.data.length
                this.loading = false
                this.convertTo(res)
                this.pagination = res.data.pagination
                this.step++
              })
              .finally((res) => {
                this.addStepLoading = false
              })
          }
        })
      } else {
        this.step++
      }
    },
    //上一步
    minusStep() {
      if (this.step == 3) {
        const data = {
          schoolId: this.schoolId,
          startDate: moment(this.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.endDate).format('YYYY-MM-DD'),
        }
        this.loading = true
        education.affectedClass(data).then((res) => {
          this.loading = false
          this.convertTo(res)
          this.pagination = res.data.pagination
        })
      }
      this.step--
    },
    // 关闭
    clickcancel() {
      this.clear()
    },
    // 完成
    submit() {
      const data = {
        schoolId: this.schoolId,
        startDate: moment(this.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.endDate).format('YYYY-MM-DD'),
        planName: this.planName,
        days: Math.ceil((this.endDate - this.startDate) / 86400000),
      }
      this.submitLoading = true
      // console.log('createdLessonPlandata', data)
      education
        .createdLessonPlan(data)
        .then((res) => {
          // console.log('createdLessonPlanres', res)
          this.$message.success('操作成功')
          this.$parent.getCourseList({
            schoolId: this.schoolId,
            currentPage: 1,
          })
          this.clear()
          this.visible = false
        })
        .finally((res) => {
          this.submitLoading = false
        })
    },
    //开始时间限制
    disabledStartDate(current) {
      return current && current < moment()
    },
    //结束时间限制
    disabledEndDate(current) {
      if (!this.startDate) {
        return current && current < moment()
      }
      return current && current < this.startDate
    },
    convertTo(res) {
      this.affectedClassList = res.data.map((item) => {
        if (!item.teachingPlan) {
          item.teachingPlan = '[]'
        }
        let gradeList = item.gradeScope.split(',')
        gradeList.forEach((v, i) => {
          if (v == 4) gradeList[i] = '一年级'
          if (v == 5) gradeList[i] = '二年级'
          if (v == 6) gradeList[i] = '三年级'
          if (v == 7) gradeList[i] = '四年级'
          if (v == 8) gradeList[i] = '五年级'
          if (v == 9) gradeList[i] = '六年级(小)'
          if (v == 222) gradeList[i] = '六年级(初)'
          if (v == 147) gradeList[i] = '七年级'
          if (v == 148) gradeList[i] = '八年级'
          if (v == 149) gradeList[i] = '九年级'
          if (v == 234) gradeList[i] = '高一'
          if (v == 235) gradeList[i] = '高二'
          if (v == 236) gradeList[i] = '高三'
        })
        item.gradeScope = gradeList.join('、')
        return { ...item, gradeScope: item.gradeScope }
      })
    },
    clear() {
      this.form.resetFields()
      this.step = 1
      this.affectedClassList = []
      this.differenceTime = 0
      this.currentPage = {}
      this.startDate = null
      this.endDate = null
    },
  },
}
</script>

<style lang="scss" scoped>
.steps-oper {
  text-align: right;
  padding: 0px 10px;
  .submit {
    margin-left: 10px;
  }
  .prev {
    margin-right: 10px;
  }
}
.step-two {
  .influence {
    margin-bottom: 15px;
  }
}
.msg {
  margin-left: 100px;
  margin-right: 100px;
  margin-bottom: 20px;
  text-align: left;
}
.tip {
  width: 75%;
  color: red;
  margin: 0 auto;
}
</style>
